import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon';

function SignatureIcon(props) {
    return (
        <SvgIcon viewBox="0 0 911.874 911.874" {...props}>
            <path d="M875.149,824.874c-1.4,0-2.7,0.1-4.101,0.3l-245.699,31.8c-12.601,1.601-21.4-12.2-14.601-23c3.7-5.7,7.3-11.5,10.9-17.3
		c9.5-15.4-3.2-35.9-20.8-35.9c-1.2,0-2.4,0.101-3.7,0.301l-322,48.399l-38.5,5.8l-105,15.801c-11.9,1.8-19.9,11.899-18.9,24
		c0.4,5.399,2.6,10.5,6.1,14.3c4.101,4.5,9.801,7,16,7c1.2,0,2.4-0.101,3.7-0.3l383.801-57.7c13.1-2,22.1,12.8,14.399,23.6
		c-2.5,3.4-5,6.9-7.5,10.3c-6.899,9.4-5.3,25.101,2.7,33.2c4.1,4.2,9.3,6.4,14.8,6.4c0.601,0,1.3,0,1.9-0.101h0.1h0.101
		l331.3-42.199h0.1h0.101c5.699-0.9,10.699-4.2,14-9.301c3.6-5.6,4.899-12.5,3.3-18.699
		C895.049,831.474,886.249,824.874,875.149,824.874z"/>
            <path d="M46.649,847.273c-3.2,4.301,1.699,9.9,6.399,7.4c53.601-29.3,107.5-42.8,137.101-46c10.6-1.1,19.399-8.8,21.699-19.2
		c14.2-63,102.801-208.1,102.801-208.1l-118.7-87.3c0,0-112.101,127.3-168.101,159.699c-9.199,5.301-14.199,15.9-12.1,26.4
		c5.7,29.1,9.9,83.3-2.1,143c-1,5.2,5.8,8.2,8.899,3.9l144.601-196.301c5.199-7,15.1-8.199,21.8-2.5l0.899,0.801
		c6,5.1,7.101,14,2.4,20.3L46.649,847.273z"/>
            <path d="M210.349,467.273l125.501,92.4c11,8.1,26.6,5.9,34.8-5.1c25.6-34.101,83.3-101,155.399-120.801l171.9-238.1
		c8.2-11.1,5.8-26.8-5.3-35l-211.7-155.8c-11.1-8.2-26.8-5.8-35,5.3l-171.7,238c2.5,74.7-44.3,149.7-69.3,184.3
		C196.949,443.574,199.349,459.074,210.349,467.273z"/>
        </SvgIcon>
    );
}

export default SignatureIcon;